import {Load} from "./Load";
import {Lightbox} from "./Lightbox";
import {Basic} from "./Basic";
import {Filter} from "./Filter";

export class History
{
    static push_url(url, skipReplace, searchterm)
    {
        if(!skipReplace && history.state)
        {
            // replace current url with scroll position
            // set current searchterm if available
            History.replace_url(true, history.state.searchterm)

            // scroll to top
            Basic.scroll_toTop();
        }

        // push new url
        history.pushState({
            v: url,
            scrollY: 0,
            searchterm: searchterm ? searchterm : null
        }, document.title, url);

        // update return url for ISE
        if(document.body.dataset.ise === 'on')
        {
            const iseExit = document.body.querySelector('.ise.ise--exit');
            if(iseExit)
            {
                iseExit.href = iseExit.href.replace(/url=.*/, 'url=' + document.location.pathname);
            }
        }
    }

    static replace_url(storeScroll, searchterm)
    {
        const data = {
            v: document.location.pathname,
            scrollY: 0
        };

        if(storeScroll === true)
        {
            data.scrollY = window.scrollY;

            // store filter and search values
            Filter.initialize();
            data.calendarFilters = Filter.calendarFilters;
            data.filter = Filter.category;
            data.search = Filter.searchTerm;
            data.searchterm = searchterm ? searchterm : null
        }
        else if(document.location.hash)
        {
            data.v += document.location.hash;
        }

        history.replaceState(data,'', data.v);
    }

    static add_event()
    {
        window.addEventListener('popstate',e =>
        {
            if(e.state && e.state.v)
            {
                Load.post({
                    f: 'load',
                    url: e.state.v,
                    calendarFilters: e.state.calendarFilters,
                    filter: e.state.filter,
                    search: e.state.search,
                    fulltextSearch: e.state.searchterm
                }).then(r =>
                {
                    // retrieve scroll position
                    if(e.state.scrollY)
                    {
                        r.scrollY = e.state.scrollY;
                    }
                    Lightbox.close();
                    Basic.update_page(r);
                }).catch(r =>
                {
                    console.error(r, e.state.v);
                });
            }
        });
    }
}
